import { useMapDispatch } from "../../../../../../stateManagement/hooks/useMapDispatch";
import { MapName } from "../../../../../../stateManagement/reducers/maps/actions";
import { store } from "../../../../../../stateManagement/store";

export function configureTreeCheckboxNodes(rawNodes: any[], parentKey = ''): { nodes: any[], selectedValues: any } {
    if (!Array.isArray(rawNodes)) return { nodes: [], selectedValues: {} };

    const selectedValues: any = {};

    const nodes = rawNodes.map((rawNode: any, index: number) => {
        const key = parentKey ? `${parentKey}-${index}` : `${index}`;
        const {
            caption: label,
            value: data,
            checked = false,
            children = [],
        } = rawNode;

        /* рекурсивно разбираем потомков */
        const { nodes: childNodes, selectedValues: childSelectedValues } = configureTreeCheckboxNodes(children, key);

        /*  ------ вычисляем состояние текущего узла ------ */
        const childKeys = Object.keys(childSelectedValues);
        const allChildChecked = childKeys.every(
            (k) => childSelectedValues[k].checked
        );
        const someChildChecked = childKeys.some(
            (k) => childSelectedValues[k].checked
        );

        const nodeChecked = checked || (childKeys.length && allChildChecked);
        const nodePartial = someChildChecked && !allChildChecked;

        selectedValues[key] = {
            checked: nodeChecked,
            partialChecked: nodePartial,
        };

        /* добавляем состояние детей в общий объект */
        Object.assign(selectedValues, childSelectedValues);

        return {
            key,
            label,
            ...(data ? { data } : {}),
            ...(childNodes.length ? { children: childNodes } : {}),
        };
    });

    return { nodes, selectedValues };
}

/**
 * Универсальный патч tree-checkbox-фильтра.
 *
 * @param mapName    карта (WaysideLandLots, Roads…)
 * @param fieldName  encumbranceType | rightType
 * @param patch  часть состояния фильтра для изменения
 *  | { ignore: boolean }
    | { includeNull: boolean }
    | { searchValue: string }
    | { selectedValues };
 * @param dispatchMap dispatch-хелпер из useMapDispatch
 */
export function patchFilterTreeCheckboxState(
    mapName: MapName,
    fieldName: string,
    patch: any,
    dispatchMap: ReturnType<typeof useMapDispatch>,
) {
    const lowerFirstMapName = mapName[0].toLowerCase() + mapName.slice(1) as MapName
    const currentFilterState = store.getState().maps[lowerFirstMapName].mapFiltersState[fieldName];
    let patchForSend: any = {}
    if (!currentFilterState) return;

    // строится patchForSend */
    const { isIgnored, includeNull, searchValue, selectedValues } = patch ?? {}
    if ('isIgnored' in patch) patchForSend = { isIgnored }
    if ('includeNull' in patch) {
        patchForSend = { isIgnored: false, includeNull }
    }
    if ('searchValue' in patch) patchForSend = { searchValue }
    if ('selectedValues' in patch) {
        patchForSend = { isIgnored: false, selectedValues }
    }

    dispatchMap(mapName, 'patchMapFiltersState', { fieldName, patch: patchForSend });
}

function checkTreeCheckboxHasSearchValue(nodes: any, searchValue: string, count: number) {
    nodes && nodes.map((treeValue: any) => {
        const { label, children } = treeValue ?? {}
        if (searchValue && label.toLowerCase().includes(searchValue.toLowerCase())) {
            count++
        }
        if (children) {
            count = checkTreeCheckboxHasSearchValue(children, searchValue, count)
        }
    })
    return count;
}

export function getAppliedValuesFromSelectedValues(nodes: any, selectedValues: any, appliedValues = {}) {
    nodes.map((node: any) => {
        const { key, data, children } = node ?? {}
        if (data) {
            let checked = Object.keys(selectedValues).includes(key)
            if (checked) {
                Object.assign(appliedValues, { [data]: checked })
            }
        }
        if (children) {
            getAppliedValuesFromSelectedValues(children, selectedValues, appliedValues)
        }
    })
    return appliedValues
}

export function countAppliedFiltersFromSelectedValues(nodes: any, selectedValues: any, appliedFiltersNumber = 0) {
    nodes.map((node: any) => {
        const { key, data, children } = node ?? {}
        if (data) {
            let checked = Object.keys(selectedValues).includes(key)
            if (checked) appliedFiltersNumber++;
        }
        if (children) {
            appliedFiltersNumber = countAppliedFiltersFromSelectedValues(children, selectedValues, appliedFiltersNumber)
        }
    })
    return appliedFiltersNumber
}